'use strict';

var capAddressConfig = [];
var param_dataSearchStreet = {};
const callWebService = require('./serverActions/callWebService');
var urlCapAddressConfig = $("#url-cap-address-config").val();
var urlCapAddressSearchAddress = $("#url-cap-address-searchaddress").val();

/// Call Ajax for get All configuration 

$.ajax({
    url: urlCapAddressConfig,
    type: 'get',
    async: false,
    dataType: 'json',
    success: function (data) {
        var capConfiguration = data.result;
        capAddressConfig = capConfiguration.length > 0 ? JSON.parse(capConfiguration) : [];
    },
    error: function (err) { }
});

/**
 * @function getConfig return all the form id
 * @param {idForm}
*/

function getConfig(idForm) {
    if (capAddressConfig.length > 0) {
        return capAddressConfig.find(form => form.idForm === idForm)
    }
}

/**
 * @function getIdForms return all the form id
*/
function getIdForms() {
    var ids = [];
    capAddressConfig.forEach(obj => {
        ids.push(obj.idForm);
    });
    return ids;
}

/**
 * @function checkStreetNumber Resulat ajax for get suggestions
 * @param {currentAddressObject}
*/
async function checkStreetNumber(currentAddressObject, $zipSelector) {
    var postalCodeaddress = '';
    $.ajax({
        url: urlCapAddressSearchAddress,
        type: 'get',
        async: false,
        data: currentAddressObject,
        dataType: 'json',
        success: function (data) {
            if (data) {
                if (data.addresses) {
                    postalCodeaddress = data.addresses[0].postalCode;
                    if ($zipSelector.length > 0) {
                        $zipSelector.attr('data-countryCode', data.addresses[0].countryCode);
                        $zipSelector.attr('data-languageCode', data.addresses[0].languageCode);
                        $zipSelector.attr('data-quality-code', data.addresses[0].qualityCode);
                        $zipSelector.attr('data-localityId', data.addresses[0].localityId);
                        $zipSelector.attr('data-postalCode', data.addresses[0].postalCode);
                        $zipSelector.attr('data-locality', data.addresses[0].locality);
                        $zipSelector.attr('data-streetId', data.addresses[0].streetId);
                        $zipSelector.attr('data-streetName', data.addresses[0].streetName);
                        $zipSelector.attr('data-streetFlags', data.addresses[0].streetFlags);
                        $zipSelector.attr('data-streetType', data.addresses[0].streetType);
                        $zipSelector.attr('data-streetInfo_1', data.addresses[0].streetInfo_1);
                        $zipSelector.attr('data-streetInfo_2', data.addresses[0].streetInfo_2);
                        $zipSelector.attr('data-streetInfo_5', data.addresses[0].streetInfo_5);
                        $zipSelector.attr('data-streetNumber', data.addresses[0].streetNumber);
                        $zipSelector.attr('data-streetNumberPosition', data.addresses[0].streetNumberPosition);
                    }
                }
            }
        },
        error: function (err) { }
    });

    return postalCodeaddress;
}

/**
 * @function dataSourceZipCode Resulat ajax for get suggestions
 * @param {configCurrentForm}
*/

async function dataSourceZipCode(configCurrentForm) {
    var $zipCodeSelector = $("#" + configCurrentForm.zipID);
    var searchResulat = await callWebService.SearchLocality('SearchLocality', $zipCodeSelector.val());
    if (searchResulat.error) {
        var address1 = 'input[name$="_address_address1"]';
        var address2 = 'input[name$="_address_address2"]';
        $(address1).attr("disabled", false);
        $(address2).attr("disabled", false);
    } else {
        var finalDatasource = null;
        finalDatasource = $.map(searchResulat.addresses, function (item) {
            if (item.inputOutput) {
                return {
                    label: item.inputOutput,
                    value: item.postalCode,
                    inputOutput: item.inputOutput,
                    step: item.step,
                    qualityCode: item.qualityCode,
                    localityId: item.localityId,
                    postalCode: item.postalCode,
                    locality: item.locality,
                    localityFlags: item.localityFlags,
                    localitySynonym: item.additionalInfo_7,
                    county: item.localityInfo_3
                }
            }
        });

        $zipCodeSelector.autocomplete({
            create: function (event, ui) {
                $(this).attr('autocomplete', 'nope');
            },
            source: function (request, response) {
                var items = [];

                $.each(finalDatasource, function (key, val) {
                    items.push(val);
                });

                response(items);

            },
            minLength: 0,
            autoFocus: true,
            select: function (event, ui) {
                $(this).next().html(ui.item.inputOutput);
                $(this).removeClass('is-invalid');

                $("#" + configCurrentForm.cityID).removeClass('is-invalid');
                $("#" + configCurrentForm.cityID).attr("disabled", false);
                $("#" + configCurrentForm.addressID_1).focus();

                $(this).attr('data-quality-code', ui.item.qualityCode);

                if (typeof ui.item.localitySynonym !== "undefined" && ui.item.localitySynonym !== undefined) {
                    ui.item.locality += ' (' + ui.item.localitySynonym + ')';
                }

                $("#" + configCurrentForm.cityID).val(ui.item.locality);

                var dataSearchStreet = {
                    inputOutput: ui.item.inputOutput,
                    step: ui.item.step,
                    qualityCode: ui.item.qualityCode,
                    localityId: ui.item.localityId,
                    postalCode: ui.item.postalCode,
                    locality: ui.item.locality,
                    streetNumber: ui.item.streetNumber,
                    localityFlags: ui.item.localityFlags
                }

                param_dataSearchStreet = dataSearchStreet;
                dataSourceAddress(configCurrentForm, param_dataSearchStreet);
                setTimeout(function () {
                    var address2 = 'input[name$="_address2"]';
                    var address1 = 'input[name$="_address1"]';
                    $("#" + configCurrentForm.addressID_1).attr("disabled", false);
                    $("#" + configCurrentForm.addressID_1).focus();
                    $(address2).attr("disabled", false);
                    $(address1).attr("disabled", false);
                },200);
            },

        }).focus(function (e) {
            return false;
        });

        if (finalDatasource.length > 0 ) {
            $zipCodeSelector.autocomplete('search', '');
        }
    }
}


/**
 * @function dataSourceZipCode Resulat ajax for get suggestions
 * @param {configCurrentForm}
*/

async function dataSourceAddressByZipCode(configCurrentForm) {
    var $zipCodeSelector = $("#" + configCurrentForm.zipID);
    var $citySelector = $("#" + configCurrentForm.cityID);

    var $address1 = $("#" + configCurrentForm.addressID_1)
    var $address2 = $('input[name$="address2"]');
    var $county = $('input[name$="_stateCode"]');

    var params = {
        inputOutput: $zipCodeSelector.val(),
        step: 'SearchAddressByPostalCode'
    }
    var searchResulat = await callWebService.searchAddressByPostalCode(params);
    if (searchResulat.error) {

        $address1.attr("disabled", false);
        $address2.attr("disabled", false);
    } else {

        var finalDatasource = null;
        finalDatasource = $.map(searchResulat.addresses, function (item) {
            if (item.inputOutput) {
                return {
                    label: item.inputOutput,
                    value: item.postalCode,
                    inputOutput: item.inputOutput,
                    step: item.step,
                    qualityCode: item.qualityCode,
                    localityId: item.localityId,
                    postalCode: item.postalCode,
                    locality: item.locality,
                    localityFlags: item.localityFlags,
                    localitySynonym: item.additionalInfo_7,
                    streetNumber: item.streetNumber,
                    streetName: item.streetName,
                    company: item.company,
                    buildingName: item.buildingName,
                    county: item.localityInfo_3
                }
            }
        });

        $zipCodeSelector.autocomplete({
            create: function (event, ui) {
                $(this).attr('autocomplete', 'nope');
            },
            source: function (request, response) {
                var items = [];

                $.each(finalDatasource, function (key, val) {
                    items.push(val);
                });
                response(items);

            },
            minLength: 0,
            change: function (event, ui) {
                var check = $(this).data('ui-autocomplete') != undefined;
                if (check && $(this).val() !== "") {
                    $zipCodeSelector.autocomplete("search", "");
                }
            },
            autoFocus: false,
            select: function (event, ui) {
                $(this).next().html(ui.item.inputOutput);
                $("#" + configCurrentForm.cityID).attr("disabled", false);

                $(this).attr('data-quality-code', ui.item.qualityCode);

                if (typeof ui.item.localitySynonym !== "undefined" && ui.item.localitySynonym !== undefined) {
                    ui.item.locality += ' (' + ui.item.localitySynonym + ')';
                }

                $("#" + configCurrentForm.cityID).val(ui.item.locality)

                var streetNumber = ui.item.streetNumber ? ui.item.streetNumber + ' ' : '';
                var streetName = ui.item.streetName ? ui.item.streetName + ' ' : '';
                var company = ui.item.company ? ui.item.company + ' ' : '';
                var buildingName = ui.item.buildingName ? ui.item.buildingName + ' ' : '';
                var county = ui.item.county ? ui.item.county : '';
                if (buildingName !== '') {
                    $('input[name$="_address2"]').val(buildingName);
                }

                $address1.val(streetNumber + streetName + company);
                $county.val(county);
                $county.attr("disabled", false);
                $address1.attr("disabled", false);
                $address2.attr("disabled", false);

                $zipCodeSelector.removeClass('is-invalid');
                $zipCodeSelector.next().css('display', 'none');
                $zipCodeSelector.attr("disabled", false);

                $citySelector.removeClass('is-invalid');
                $citySelector.next().css('display', 'none');
                $citySelector.attr("disabled", false);
                $citySelector.focus();

                $address1.removeClass('is-invalid');
                $address1.next().css('display', 'none');
                $address1.attr("disabled", false);

                setTimeout(function () {
                    var address2 = 'input[name$="_address2"]';
                    var address1 = 'input[name$="_address1"]';
                    $("#" + configCurrentForm.addressID_1).attr("disabled", false);
                    $("#" + configCurrentForm.addressID_1).focus();

                    if ($("#" + configCurrentForm.addressID_1).length === 0) {
                        $(address1).attr("disabled", false);
                        $(address1).val(streetNumber + streetName + company);
                    }

                    $(address2).attr("disabled", false);
   
                },200);
            },

        }).focus(function (e) {
            if ($(this).val() !== "") {
                $(this).data("uiAutocomplete").search($(this).val());
            }
        })



        var $formSelector = $("form[id='" + configCurrentForm.idForm + "']");

        if ($formSelector.length === 0 && configCurrentForm.idForm === '"dwfrm_address"') {
            $formSelector = '"dwfrm_address"';
        }

        if ($formSelector.length === 0) {
            $formSelector = $("form[name='" + configCurrentForm.idForm + "']");
        }

        $formSelector.on("click", function (event) {
            if (!$(event.target).closest(".ui-autocomplete-input").length && $zipCodeSelector.hasClass("clickedOut")) {
                $(".ui-autocomplete").hide();
                $zipCodeSelector.removeClass("clickedOut")

            }
        });

    }
}
/**
 * @function dataSourceCity Resulat ajax for get suggestions
 * @param {configCurrentForm}
*/

async function dataSourceCity(configCurrentForm) {
    var $citySelector = $("#" + configCurrentForm.cityID);
    var $zipCodeSelector = $("#" + configCurrentForm.zipID);
    var $address1 = $("#" + configCurrentForm.addressID_1)
    var $address2 = $('input[name$="address2"]');
    var $county = $('input[name$="_stateCode"]');

    var searchResulat = await callWebService.SearchLocality('SearchLocality', $citySelector.val());
    if (searchResulat.error) {
        var address1 = 'input[name$="_address_address1"]';
        var address2 = 'input[name$="_address_address2"]';
        $(address1).attr("disabled", false);
        $(address2).attr("disabled", false);
    } else {
        var finalDatasource = null;
        finalDatasource = $.map(searchResulat.addresses, function (item) {
            if (item.inputOutput) {
                return {
                    label: item.inputOutput,
                    value: item.locality,
                    inputOutput: item.inputOutput,
                    step: item.step,
                    qualityCode: item.qualityCode,
                    localityId: item.localityId,
                    zipCode: item.postalCode,
                    locality: item.locality,
                    localityFlags: item.localityFlags,
                    localitySynonym: item.localitySynonym,
                    streetNumber: item.streetNumber,
                    streetName: item.streetName,
                    company: item.company,
                    buildingName: item.buildingName,
                    county: item.localityInfo_3
                }
            }
        });

        $citySelector.autocomplete({
            create: function (event, ui) {
                $(this).attr('autocomplete', 'nope');
                
            },
            minLength: 0,
            autoFocus: true,
            source: function (request, response) {
                var items = [];

                $.each(finalDatasource, function (key, val) {
                    items.push(val);
                });

                response(items);

            },
            select: function (event, ui) {
                var currentCountry = $("#currentCountry").val();

                $zipCodeSelector.val(ui.item.zipCode);
                $(this).removeClass('is-invalid');
                $zipCodeSelector.removeClass('is-invalid');

                $("#" + configCurrentForm.addressID_1).attr("disabled", false);
                $("#" + configCurrentForm.zipID).attr("disabled", false);

                setTimeout(function () {
                    var address2 = 'input[name$="_address2"]';
                    $("#" + configCurrentForm.addressID_1).attr("disabled", false);
                    $("#" + configCurrentForm.addressID_1).focus();
                    $(address2).attr("disabled", false);
                },200);

                var $county = $('input[name$="_stateCode"]');
                if ($county.length > 0) {
                    $county.attr("disabled", false);
                    $county.val(ui.item.county);
                }

                if (typeof ui.item.localitySynonym !== "undefined" && ui.item.localitySynonym !== undefined) {
                    ui.item.locality += ' (' + ui.item.localitySynonym + ')';
                }
                if (currentCountry === 'GB') {
                    var streetNumber = ui.item.streetNumber ? ui.item.streetNumber + ' ' : '';
                    var streetName = ui.item.streetName ? ui.item.streetName + ' ' : '';
                    var company = ui.item.company ? ui.item.company + ' ' : '';
                    var buildingName = ui.item.buildingName ? ui.item.buildingName + ' ' : '';
                    var county = ui.item.county ? ui.item.county : '';

                    $address1.val('');
                    $address2.val('');

                    if (buildingName !== '') {
                        $address2.val(buildingName);
                    }
    
                    $address1.val(streetNumber + streetName + company);
                    $county.val(county);
                }

                var dataSearchStreet = {
                    inputOutput: ui.item.inputOutput,
                    step: ui.item.step,
                    qualityCode: ui.item.qualityCode,
                    localityId: ui.item.localityId,
                    postalCode: ui.item.zipCode,
                    locality: ui.item.locality,
                    localityFlags: ui.item.localityFlags,
                    streetNumber: ui.item.streetNumber,
                    
                }
                param_dataSearchStreet = dataSearchStreet;



       

                dataSourceAddress(configCurrentForm, param_dataSearchStreet);
            }

        }).focus(function (e) {
            return false;
        });

        if (finalDatasource.length > 0 ) {
            $citySelector.autocomplete('search', '');
        }
    }
}

/**
 * @function dataSourceAddress Resulat ajax for get suggestions
 * @param {configCurrentForm}
 * @param {dataSearchStreet}
*/

async function dataSourceAddress(configCurrentForm, dataSearchStreet) {
    var $addressSelector = $("#" + configCurrentForm.addressID_1);
    var $citySelector = $("#" + configCurrentForm.cityID);
    var $zipSelector = $("#" + configCurrentForm.zipID);
    $addressSelector.attr("disabled", false);
    $('input[name$="_address2"]').attr("disabled", false);

    dataSearchStreet = null;
    if (param_dataSearchStreet) {
        param_dataSearchStreet.inputOutput = $addressSelector.val();
        dataSearchStreet = param_dataSearchStreet
    }

    if (dataSearchStreet.localityFlags === 3) {
        $addressSelector.addClass("has-proposition-false");
        return false;
    } else {
        $addressSelector.removeClass("has-proposition-false");
    }

    var searchResulat = await callWebService.SearchStreet(dataSearchStreet);
    var finalDatasource = null;

    if (searchResulat.addresses && searchResulat.addresses.length > 0) {
        var finalDatasource = $.map(searchResulat.addresses, function (item) {
            if (item.inputOutput) {
                return {
                    label: item.inputOutput,
                    value: (item.streetNumber ? item.streetNumber : '') + (item.streetNumberExt ? item.streetNumberExt : '') + ' ' + item.streetName,
                    postalCode: item.postalCode,
                    streetNumber: item.streetNumber,
                    locality: item.locality,
                    localityFlags: item.localityFlags,
                    localitySynonym: item.localitySynonym,
                    inputOutput: item.inputOutput,
                    countryCode: item.countryCode,
                    languageCode: item.languageCode,
                    qualityCode: item.qualityCode,
                    localityId: item.localityId,
                    postalCode: item.postalCode,
                    locality: item.locality,
                    localityFlags: item.localityFlags,
                    streetId: item.streetId,
                    streetName: item.streetName,
                    streetFlags: item.streetFlags,
                    streetType: item.streetType ? item.streetType : '',
                    streetSynonym: item.streetSynonym ? item.streetSynonym : '',
                    streetInfo_1: item.streetInfo_1,
                    streetInfo_2: item.streetInfo_2,
                    streetNumber: item.streetNumber,
                    streetNumberExt: item.streetNumberExt ? item.streetNumberExt : '',
                    step: item.step,
                    buildingName: item.buildingName
                }
            }
        });

        $addressSelector.autocomplete({
            create: function (event, ui) {
                $(this).attr('autocomplete', 'nope');
            },
            source: function (request, response) {
                var items = [];

                $.each(finalDatasource, function (key, val) {
                    items.push(val);
                });
                response(items);

            },
            minLength: 0,
            autoFocus: true,
            select: async function (event, ui) {
                $(this).removeClass('is-invalid');
                $citySelector.removeClass('is-invalid');
                $zipSelector.removeClass('is-invalid');
                $zipSelector.attr('data-quality-code', ui.item.qualityCode);


                if (ui.item.localitySynonym) {
                    ui.item.locality += ' (' + ui.item.localitySynonym + ')';
                }

                $(this).next().html(ui.item.inputOutput);

                if (ui.item.localityFlags !== 2) {
                    setTimeout(function () {
                        $citySelector.val(ui.item.locality);
                        $zipSelector.val(ui.item.postalCode);
                        $addressSelector.next().hide();
                    }, 100);
                }
                var objet = {
                    request: 'SearchAddress',
                    inputOutput: ui.item.inputOutput,
                    step: 'CheckStreetNumber',
                    countryCode: ui.item.countryCode,
                    languageCode: ui.item.languageCode,
                    qualityCode: ui.item.qualityCode,
                    localityId: ui.item.localityId,
                    postalCode: ui.item.postalCode,
                    locality: ui.item.locality,
                    localityFlags: ui.item.localityFlags,
                    streetId: ui.item.streetId,
                    streetName: ui.item.streetName,
                    streetFlags: ui.item.streetFlags,
                    streetType: ui.item.streetType,
                    streetSynonym: ui.item.streetSynonym,
                    streetInfo_1: ui.item.streetInfo_1,
                    streetInfo_2: ui.item.streetInfo_2,
                    streetNumber: ui.item.streetNumber,
                    streetNumberExt: ui.item.streetNumberExt,
                    jsoncallback: 'SearchAddress'
                }

                if (ui.item.step === 'CheckStreetNumber') {
                    var currentPostalCode = await checkStreetNumber(objet, $zipSelector);
                    if (currentPostalCode !== '' && ui.item.localityFlags !== 2) {
                        setTimeout(function () {
                            $zipSelector.val(currentPostalCode);
                        }, 20);
                    }
                }

                if (ui.item.buildingName) {
                    $('input[name$="_address2"]').val(ui.item.buildingName).attr("disabled", false);
                }

            }
        }).focus(function (e) {
            return false;
        })

        if (finalDatasource.length > 0 ) {
            $addressSelector.autocomplete('search', '');
        }
    }
}

/**
 * @function callProcessAddressFlow Enable UI-autocomplete form zipID
 * @param {configCurrentForm}
*/

function callProcessAddressFlow(currentFormConfig) {
    if (currentFormConfig.hasOwnProperty("zipID")) {
        dataSourceZipCode(currentFormConfig);
    }
}

/**
 * @function callProcessAddressFlow Enable UI-autocomplete form cityID
 * @param {configCurrentForm}
*/

function callProcessAddressFlowByCity(currentFormConfig) {
    if (currentFormConfig.hasOwnProperty("cityID")) {
        dataSourceCity(currentFormConfig);
    }
}

/**
 * @function callProcessAddressFlow Enable UI-autocomplete form addressID_1
 * @param {configCurrentForm}
*/

function callProcessSearchStreet(currentFormConfig) {
    if (currentFormConfig.hasOwnProperty("addressID_1")) {
        dataSourceAddress(currentFormConfig, {});
    }
}


/**
 * @function callProcessAddressFlow Enable UI-autocomplete form addressID_1
 * @param {configCurrentForm}
*/

function callProcessAddressFlowByCodePostal(currentFormConfig) {
    if (currentFormConfig.hasOwnProperty("addressID_1")) {
        dataSourceAddressByZipCode(currentFormConfig);
    }
}

module.exports = {
    getConfig: getConfig,
    getIdForms: getIdForms,
    callProcessSearchStreet: callProcessSearchStreet,
    callProcessAddressFlowByCodePostal: callProcessAddressFlowByCodePostal,
    callProcessAddressFlow: callProcessAddressFlow,
    callProcessAddressFlowByCity: callProcessAddressFlowByCity
}